<template>
  <div id="recommend">
    <a id="auto" v-on:click="recommend" :href="'line://msg/text/?親愛的朋友，我要邀請你一起加入Beauty美妝生活圈 的LINE好友，最新美妝潮流都在這裡！%0D%0A%0D%0Aline://app/1610553524-JbE9B9WV?c='+this.channelId+'&rec='+this.userId"></a>
    <img src="../assets/Beauty.jpg">
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mapGetters } from 'vuex'
export default {
  name: 'recommend',
  methods: {
    // 記錄推薦人USID //
    recommend: function() {
      this.$store.dispatch('recommend', 
      {
        c: this.channelId
      })
    }
  },
  computed: {
    ...mapGetters({
      userId: 'userId'
    }),
    ...mapGetters({
      channelId: 'channelId'
    })
  },
  mounted() {
    // <導至邀請好友>1.5s
    setTimeout(function () {
      document.getElementById('auto').click();
    }, 1500);
  }
}
</script>

<style scope>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
}
img {
  width: 80%;
  border-radius: 50%;
  margin-top: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/recommend.vue